<div class="container-fluid glb-popup proforma-container" style="max-width:100vw">
  <div class="dialog-header">
    <!-- <h2>{{ formTitle }}</h2> -->

    <button mat-icon-button mat-dialog-close class="close-btn">
      <i class="pi pi-times"></i>
    </button>
  </div>
  <mat-tab-group [(selectedIndex)]="selectedTabIndex">
    <mat-tab label="Proforma">
      <div class="proforma-tab-content">
        <h2> {{formTitle}}</h2>
        <p-toast [style]="{marginTop: '80px'}">
        </p-toast>
        <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

        @if (formLoading || loading) {
          <div class="proforma-loading-overlay">
            <mat-spinner></mat-spinner>
          </div>
        }

        <!-- <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
        <i class="pi pi-times" aria-hidden="true"></i>
      </button> -->


      @if (!isRequestedProforma) {
        <div class="viewBtn">
          @if (proformaId) {
            <button pButton (click)="onOpenFormEdit()" class="p-button p-button-outlined"><i
            class="pi pi-search"></i>&nbsp;&nbsp;View</button>
          }
        </div>
      }

      @if (proformaId && !isRequestedProforma) {
        <div class="viewCopyFromBtn">
          <button pButton (click)="onOpenFormCopyFrom(proforma)" class="p-button p-button-text"><i
          class="pi pi-copy"></i>&nbsp;&nbsp;Copy From</button>
        </div>
      }

      @if (proformaId && !isRequestedProforma) {
        <div class="viewCopyBtn">
          <button pButton (click)="onOpenFormCopyTo(proforma)" class="p-button p-button-text"><i
          class="pi pi-copy"></i>&nbsp;&nbsp;Copy To</button>
        </div>
      }

      @if (proformaId && !isRequestedProforma && !isPublicAndPublish) {
        <div class="targetBtn">
          <button pButton (click)="setTarget(proforma)" class="p-button p-button-text"><i
          class="pi pi-chart-line"></i>&nbsp;&nbsp;Target</button>
        </div>
      }
      @if (proformaId) {
        <div class="pdfBtn">
          <button pButton
            (click)="downloadAsPdf($event)"
            class="p-button p-button-text"
            [disabled]="pdfLoading">
            @if (!pdfLoading) {
              <i class="pi pi-download"></i>
            }
            @if (pdfLoading) {
              <i class="pi pi-spin pi-spinner"></i>
            }
            &nbsp;{{ pdfLoading ? 'Generating...' : 'PDF' }}
          </button>
        </div>
      }
      @if (proformaId && !isRequestedProforma) {
        <div class="shareBtn">
          <button pButton (click)="onOpenFormAddMailAndSMS()" class="p-button p-button-text" [disabled]="mailComposeLoading">
            <i [class]="mailComposeLoading ? 'pi pi-spin pi-spinner' : 'pi pi-share-alt'"></i>&nbsp;&nbsp;Share
          </button>
        </div>
      }
      @if (proformaId && proforma?.confId) {
        <div class="copyLinkBtn">
          <button pButton (click)="copyPublicLink()" class="p-button p-button-text" pTooltip="Copy public link" tooltipPosition="bottom">
            <i class="pi pi-link"></i>&nbsp;&nbsp;Copy Link
          </button>
        </div>
      }
      @if (proformaId && proforma?.confId && !isRequestedProforma) {
        <div class="sendProspectBtn">
          <button pButton (click)="toggleSendToProspectForm()" class="p-button p-button-text"
            pTooltip="Email bizdev link to prospect" tooltipPosition="bottom"
            [disabled]="sendToProspectLoading">
            <i [class]="sendToProspectLoading ? 'pi pi-spin pi-spinner' : 'pi pi-envelope'"></i>&nbsp;&nbsp;Send to Prospect
          </button>
        </div>
        @if (showSendToProspectForm) {
          <div class="send-prospect-form" style="background:#f8f9fa;border:1px solid #dee2e6;border-radius:6px;padding:16px;margin-top:8px;max-width:520px;">
            <div class="mb-3">
              <label class="form-label" style="font-weight:600;">Recipient Email</label>
              <input pInputText type="email" class="w-100" [(ngModel)]="sendToProspectPayload.recipientEmail"
                placeholder="owner@example.com" style="width:100%">
            </div>
            <div class="mb-3">
              <label class="form-label" style="font-weight:600;">Subject</label>
              <input pInputText type="text" class="w-100" [(ngModel)]="sendToProspectPayload.customSubject"
                placeholder="Subject" style="width:100%">
            </div>
            <div class="mb-3">
              <label class="form-label" style="font-weight:600;">Message (optional intro)</label>
              <textarea pInputTextarea class="w-100" [(ngModel)]="sendToProspectPayload.customMessage"
                rows="3" placeholder="Add a personal note (optional). The bizdev link will be appended automatically."
                style="width:100%"></textarea>
            </div>
            <div class="d-flex gap-2">
              <button pButton class="p-button p-button-sm" (click)="sendToProspect()"
                [disabled]="sendToProspectLoading || !sendToProspectPayload.recipientEmail">
                <i [class]="sendToProspectLoading ? 'pi pi-spin pi-spinner' : 'pi pi-send'"></i>&nbsp;Send
              </button>
              <button pButton class="p-button p-button-sm p-button-text" (click)="toggleSendToProspectForm()">
                Cancel
              </button>
            </div>
          </div>
        }
      }
      @if (proformaId && proforma?.confId && !isRequestedProforma) {
        <div class="prospect-activity-toggle">
          <button pButton (click)="showProspectActivity = !showProspectActivity" class="p-button p-button-text"
            pTooltip="View prospect engagement" tooltipPosition="bottom">
            <i class="pi pi-eye"></i>&nbsp;&nbsp;Prospect Activity
          </button>
        </div>
        @if (showProspectActivity) {
          <div class="prospect-activity-panel">
            <div class="prospect-activity-header">
              <span class="prospect-activity-title">Prospect Activity</span>
              <button pButton class="p-button p-button-sm p-button-outlined prospect-refresh-btn"
                (click)="refreshViewStats()" [disabled]="viewStatsLoading">
                <i [class]="viewStatsLoading ? 'pi pi-spin pi-spinner' : 'pi pi-refresh'"></i>&nbsp;Refresh
              </button>
            </div>
            @if (viewStatsLoading) {
              <div class="prospect-activity-loading">
                <i class="pi pi-spin pi-spinner"></i>&nbsp;Loading...
              </div>
            }
            @if (!viewStatsLoading && viewStats) {
              <div class="prospect-view-count">{{viewStats.viewCount}}</div>
              <div class="prospect-last-viewed">
                @if (viewStats.lastViewedAt) {
                  Last viewed: {{formatLastViewed(viewStats.lastViewedAt)}}
                } @else {
                  Not yet viewed
                }
              </div>
              <div class="prospect-message">
                Your prospect has opened this link {{viewStats.viewCount}} time(s)
              </div>
              @if (viewStats.viewCount >= 3) {
                <div class="prospect-hot-callout">
                  Hot lead &mdash; follow up now
                </div>
              }
            }
            @if (!viewStatsLoading && !viewStats) {
              <div class="prospect-message">No view data available.</div>
            }
          </div>
        }
      }
      @if (proformaId) {
        <div class="deleteBtn">
          <button pButton (click)="onFormDelete()" class="p-button p-button-text p-button-danger">
            <i class="pi pi-trash"></i>&nbsp;&nbsp;Delete
          </button>
        </div>
      }
      <hr>
        <div [formGroup]="form1" class="forms w-100 d-block">

          <div class="row m-0">

            <div class="col-lg-12">
              @if (formAlert) {
                <div class="w-100 mb-4">
                  <div class="w-100"
                    style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                    <p><b>{{formAlert}}</b></p>
                  </div>
                </div>
              }
            </div>

            <!-- Somewhere up here put a BUTTON O Proforma-view -->
            <!--Proforma View Button-->

            <!--All Relations mapping-->

            @if (isRequestedProforma) {
              <div>
                <div class="col-10 row mb-6">
                  <div class="col-lg-12">
                    <span>
                      Property of Mls record : <b>{{proforma?.realEstateProperty?.displayLabel}}</b>
                    </span>
                    <span>
                      <button class="btn btn-icon btn-success rounded-pill ml-2"
                        (click)="redirectToMlsProperty(form1.get('mlsAllId').value)">
                        View
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            }

            @if (isRequestedProforma) {
              <div>
                <div class="col-10 row py-0">
                  <div class="col-lg-12">
                    <span class="p-float-label required-field w-100 mb-4">
                      @if (proformaList?.length > 0) {
                        <p-dropdown [options]="proformaList"
                          formControlName="proformaId" optionLabel="customOption" appendTo="body"
                          optionValue="proformaId" (onChange)="onSelectProforma($event)" [filter]="true"
                          filterBy="name" [showClear]="false" placeholder="Copy Proforma From"
                          [dropdownIcon]="'fa fa-caret-down'">
                        </p-dropdown>
                      }
                      <label for="Copy Proforma From">Copy Proforma From</label>
                      <span>
                        @if (proformaNotSelected) {
                          <small class="p-invalid">Please Select Proforma to be
                            copied.
                          </small>
                        }
                      </span>
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 row py-0">
                    <div class="col-lg-12">
                      <span class="p-float-label required-field w-100 mb-4">
                        <p-autoComplete class="col-lg-12" [suggestions]="filteredPropertyLeadProfiles"
                          [multiple]="true" [forceSelection]="false" [dropdown]="false"
                          [style]="{'width':'100%','padding-bottom':'20px'}" [inputStyle]="{'width':'100%'}"
                          [minLength]="1" formControlName="propertyLeadProfiles" unique="true"
                          field="displayLabel"
                          placeholder="Search and Select Property from PropertyLeadProfile"
                          (onSelect)="onPropertySelect($event)" (completeMethod)="filterProperties($event)">
                        </p-autoComplete>
                        <label for="propertyLeadProfiles">Search and Select Property from
                        PropertyLeadProfile</label>
                      </span>
                      <span>
                        @if (propertyNotSelected) {
                          <small class="p-invalid">Please Select Property or Add New
                            Property if not available.
                          </small>
                        }
                      </span>
                      <span>
                        <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="addNewProperty()">
                          <i class="pi pi-plus"></i>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <span class="p-float-label w-100 mb-4">
                    <p-calendar formControlName="preparedDate" inputId="preparedDate">
                    </p-calendar>
                    <label for="preparedDate">Prepared Date</label>
                    @for (validation of validationMessages.preparedDate; track validation) {
                      <span>
                        @if (form1.get('preparedDate').hasError(validation.type) && (form1.get('preparedDate').dirty || form1.get('preparedDate').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
                <div class="col-lg-6">
                  <span class="p-float-label required-field w-100 mb-4">
                    <p-dropdown readonly="true" [options]="visibilities" formControlName="visibility"
                      optionLabel="name" optionValue="value" placeholder="Proforma Visibility"
                    [dropdownIcon]="'fa fa-caret-down'"></p-dropdown>
                    <label for="Proforma Visibility">Visibility</label>
                    @for (validation of validationMessages.visibility; track validation) {
                      <span>
                        @if (form1.get('visibility').hasError(validation.type) && (form1.get('visibility').dirty || form1.get('visibility').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
                <div class="col-lg-6">
                  <span class="p-float-label w-100 mb-4">
                    <p-dropdown [options]="statuses" readonly="true" formControlName="status" optionLabel="name"
                      optionValue="value" appendTo="body" placeholder="Proforma Status"
                    [dropdownIcon]="'fa fa-caret-down'"></p-dropdown>
                    <label for="Proforma Status">Proforma Status</label>
                    @for (validation of validationMessages.status; track validation) {
                      <span>
                        @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
                @if (form1.get('realtorProfileId').value) {
                  <div class="col-10 row py-0">
                    <div class="col-lg-12">
                      <span class="p-float-label required-field w-100 mb-4">
                        @if (realtorProperties?.length > 0) {
                          <p-dropdown readonly="true"
                            [options]="realtorProperties" formControlName="realtorProfileId"
                            optionLabel="displayLabel" appendTo="body" optionValue="realtorProfileId"
                            [filter]="true" filterBy="displayLabel" (onChange)="changeRealtorProfile($event)"
                            placeholder="Select Property of realtorProfile" [dropdownIcon]="'fa fa-caret-down'">
                          </p-dropdown>
                        }
                        <label for="Select Property of realtorProfile">Property of realtorProfile</label>
                        @for (validation of validationMessages.realtorProfileId; track validation) {
                          <span>
                            @if (form1.get('realtorProfileId').hasError(validation.type) && (form1.get('realtorProfileId').dirty || form1.get('realtorProfileId').touched)) {
                              <small class="p-invalid"
                                >{{validation.message}}
                              </small>
                            }
                          </span>
                        }
                      </span>
                    </div>
                  </div>
                }
                <hr>
                  <div class="row m-0">
                    <div class="col-lg-12">
                      <div class="btn-group">
                        <div class="button-group">
                          <button pButton class="btn-cancel p-button-text"
                          [mat-dialog-close]="true">Cancel</button>
                          <button pButton class="btn-upt p-button" (click)="copyProformaFromExisting()">Copy
                          Proforma</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              @if (!isRequestedProforma) {
                <div>
                  <div class="fw-bold mb-2 title">Assigned To</div>
                  <div class="row">
                    <div class="col-lg-4">
                      <span class="p-float-label required-field w-100 mb-4">
                        <input formControlName="name" id="name" type="text" pInputText>
                        <label for="name">Proforma Name&nbsp;<span class="text-danger">*</span></label>
                        @for (validation of validationMessages.name; track validation) {
                          <span>
                            @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                              <small class="p-invalid"
                                >{{validation.message}}
                              </small>
                            }
                          </span>
                        }
                      </span>
                    </div>
                    <div class="col-lg-3">
                      <span class="p-float-label w-100 mb-4">
                        <p-dropdown [options]="statuses" formControlName="status" optionLabel="name"
                          (onChange)="formUpdate()" optionValue="value" placeholder="Proforma Status"
                        [dropdownIcon]="'fa fa-caret-down'"></p-dropdown>
                        <label for="Proforma Status">Proforma Status</label>
                        @for (validation of validationMessages.status; track validation) {
                          <span>
                            @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                              <small class="p-invalid"
                                >{{validation.message}}
                              </small>
                            }
                          </span>
                        }
                      </span>
                    </div>
                    <div class="col-lg-2">
                      <span class="p-float-label w-100 mb-4">
                        <p-calendar formControlName="preparedDate" inputId="preparedDate">
                        </p-calendar>
                        <label for="preparedDate">Prepared Date</label>
                        @for (validation of validationMessages.preparedDate; track validation) {
                          <span>
                            @if (form1.get('preparedDate').hasError(validation.type) && (form1.get('preparedDate').dirty || form1.get('preparedDate').touched)) {
                              <small class="p-invalid"
                                >{{validation.message}}
                              </small>
                            }
                          </span>
                        }
                      </span>
                    </div>
                    <div class="col-lg-2 row py-0">
                      <span class="p-float-label required-field w-100 mb-4">
                        <p-dropdown [options]="visibilities" formControlName="visibility" optionLabel="name"
                          (onChange)="formUpdate()" optionValue="value" placeholder="Proforma Visibility"
                        [dropdownIcon]="'fa fa-caret-down'"></p-dropdown>
                        <label for="Proforma Visibility">Visibility</label>
                        @for (validation of validationMessages.visibility; track validation) {
                          <span>
                            @if (form1.get('visibility').hasError(validation.type) && (form1.get('visibility').dirty || form1.get('visibility').touched)) {
                              <small class="p-invalid"
                                >{{validation.message}}
                              </small>
                            }
                          </span>
                        }
                      </span>
                    </div>
                    <div class="col-lg-3">
                      <span class="p-float-label w-100 mb-4">
                        <p-dropdown [options]="templates" formControlName="proformaTemplateId" optionLabel="templateName"
                          optionValue="proformaTemplateId" placeholder="Template" [showClear]="true"
                        [dropdownIcon]="'fa fa-caret-down'" appendTo="body"></p-dropdown>
                        <label for="proformaTemplateId">Template</label>
                      </span>
                    </div>
                    <div class="col-lg-6 row py-0">
                      <div class="col-lg-12">
                        <span class="p-float-label required-field w-100 mb-4">
                          <p-autoComplete class="col-lg-12" [suggestions]="agentUserSuggestions"
                            [multiple]="false" [forceSelection]="false" [dropdown]="false"
                            [style]="{'width':'100%','padding-bottom':'20px'}" [inputStyle]="{'width':'100%'}"
                            [minLength]="2" unique="true" field="summary" (completeMethod)="onKeyInput($event)"
                          formControlName="createByProfile"> </p-autoComplete>
                          <label for="createByProfile">Sales Agent1</label>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="row d-flex justify-content-between">
                    <div class="col-10 row py-0">
                      <div class="col-lg-12">
                        <span class="p-float-label fullwidthinput required-field w-100 mb-3">
                          <p-autoComplete #locationSearch class="col-lg-12"
                            [suggestions]="filteredPropertyLeadProfiles" [forceSelection]="true" appendTo="body"
                            placeholder="" formControlName="propertyLeadProfile"
                            (completeMethod)="filterProperties($event.query)" field="displayLabel"
                            [minLength]="1" (onSelect)="onPropertyLeadProfileSelect($event)">
                          </p-autoComplete>
                          <label for="propertyLeadProfiles">Property from Property Lead Profile&nbsp;@if (form1?.get?.('status')?.value != 3) {
                            <span class="text-danger">*</span>
                          }</label>
                          @for (validation of validationMessages.propertyLeadProfile; track validation) {
                            <span>
                              @if (form1.get('propertyLeadProfile').hasError(validation.type) && (form1.get('propertyLeadProfile').dirty || form1.get('propertyLeadProfile').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                        <span class="p-float-label required-field w-100 mb-4">
                        </span>
                      </div>
                    </div>
                    <!-- Hide if visibility is Public and published-->
                    @if (form1.get('visibility').value != 0 || form1.get('status').value != 1) {
                      <div class="col-1 py-0 d-flex justify-content-end align-items-center"
                        >
                        <button class="btn btn-icon btn-success rounded-pill mb-4" (click)="formAddPropertyLead()">
                          <i class="pi pi-plus"></i>
                        </button>
                      </div>
                    }
                    <!-- Hide if visibility is Public and published-->
                    @if (form1.get('visibility').value != 0 || form1.get('status').value != 1) {
                      <div class="col-1 py-0 d-flex justify-content-end align-items-center"
                        >
                        @if (form1.controls['propertyLeadProfile'].value) {
                          <button class="btn btn-icon mb-4"
                            (click)="formEditPropertyLead()">
                            <i class="pi pi-pencil" aria-hidden="true" style="color:blue;"></i>
                          </button>
                        }
                      </div>
                    }
                  </div>
                  <!-- Hide if visibility is Public and published-->
                  @if (form1.get('visibility').value != 0 || form1.get('status').value != 1) {
                    <div class="row d-flex justify-content-between"
                      >
                      <div class="col-10 row py-0">
                        <div class="col-lg-12">
                          <span class="p-float-label required-field w-100 mb-4">
                            @if (realtorProperties?.length > 0) {
                              <p-dropdown [options]="realtorProperties"
                                formControlName="realtorProfileId" optionLabel="displayLabel" appendTo="body"
                                optionValue="realtorProfileId" [filter]="true" filterBy="displayLabel"
                                (onChange)="changeRealtorProfile($event)" [showClear]="true"
                                placeholder="Select Property of realtorProfile" [dropdownIcon]="'fa fa-caret-down'">
                              </p-dropdown>
                            }
                            <label for="Select Property of realtorProfile">Select Property of realtorProfile</label>
                            @for (validation of validationMessages.realtorProfileId; track validation) {
                              <span>
                                @if (form1.get('realtorProfileId').hasError(validation.type) && (form1.get('realtorProfileId').dirty || form1.get('realtorProfileId').touched)) {
                                  <small class="p-invalid"
                                    >{{validation.message}}
                                  </small>
                                }
                              </span>
                            }
                          </span>
                        </div>
                      </div>
                      <div class="col-1 py-0 d-flex justify-content-end align-items-center">
                        <button class="btn btn-icon btn-success rounded-pill mb-4" (click)="formAddRealtorProfile()">
                          <i class="pi pi-plus"></i>
                        </button>
                      </div>
                      <div class="col-1 py-0 d-flex justify-content-end align-items-center">
                        @if (form1.controls['realtorProfileId'].value) {
                          <button class="btn btn-icon mb-4"
                            (click)="formEditRealtorProfile()">
                            <i class="pi pi-pencil" aria-hidden="true" style="color:blue;"></i>
                          </button>
                        }
                      </div>
                    </div>
                  }
                  <!-- Hide if visibility is Public and published-->
                  @if ((form1.get('visibility').value != 0 || form1.get('status').value != 1)) {
                    <div class="row d-flex justify-content-between"
                      >
                      <div class="col-10 row py-0">
                        <div class="col-lg-12">
                          <span class="p-float-label required-field w-100 mb-4">
                            @if (ownerLeadProperties?.length > 0) {
                              <p-dropdown [options]="ownerLeadProperties"
                                formControlName="ownerLeadProfileId" optionLabel="displayLabel"
                                optionValue="ownerLeadProfileId" [filter]="true" appendTo="body"
                                (onChange)="changeOwnerLeadProfile($event)" filterBy="displayLabel"
                                [showClear]="true" placeholder="Select Property of ownerLeadProfile"
                                [dropdownIcon]="'fa fa-caret-down'">
                              </p-dropdown>
                            }
                            <label for="Select Property of ownerLeadProfile">Select Property of ownerLeadProfile
                            </label>
                            @for (validation of validationMessages.ownerLeadProfileId; track validation) {
                              <span>
                                @if (form1.get('ownerLeadProfileId').hasError(validation.type) && (form1.get('ownerLeadProfileId').dirty || form1.get('ownerLeadProfileId').touched)) {
                                  <small class="p-invalid"
                                    >{{validation.message}}
                                  </small>
                                }
                              </span>
                            }
                          </span>
                        </div>
                      </div>
                      <div class="col-1 py-0 d-flex justify-content-end align-items-center">
                        <button class="btn btn-icon btn-success rounded-pill mb-4" (click)="formAddOwnerLeadProfile()">
                          <i class="pi pi-plus"></i>
                        </button>
                      </div>
                      <div class="col-1 py-0 d-flex justify-content-end align-items-center">
                        @if (form1.controls['ownerLeadProfileId'].value) {
                          <button class="btn btn-icon mb-4"
                            (click)="formEditOwnerLeadProfile()">
                            <i class="pi pi-pencil" aria-hidden="true" style="color:blue;"></i>
                          </button>
                        }
                      </div>
                    </div>
                  }
                  <div>
                    <div class="fw-bold my-2 title">Contract Terms</div>
                    <div class="row contract-modifications">
                      <div class="col-lg-2">
                        <span class="p-float-label mb-3">
                          <input [style]="{'width':'100%'}" formControlName="numProperties"
                            id="numProperties" type="number" min="1" pInputText
                            (change)="onDealParamChange()">
                          <label for="numProperties">Properties in Deal</label>
                        </span>
                      </div>
                      <div class="col-lg-2">
                        <span class="p-float-label mb-3">
                          <input [style]="{'width':'100%'}" formControlName="initialTermLengthMonths"
                            id="initialTermLengthMonths" type="number" pInputText>
                            <label for="initialTermLengthMonths">Init. Term (mo.)</label>
                            @for (validation of validationMessages.initialTermLengthMonths; track validation) {
                              <span>
                                @if (form1.get('initialTermLengthMonths').hasError(validation.type) && (form1.get('initialTermLengthMonths').dirty || form1.get('initialTermLengthMonths').touched)) {
                                  <small class="p-invalid"
                                    >{{validation.message}}
                                  </small>
                                }
                              </span>
                            }
                          </span>
                        </div>
                        <div class="col-lg-2">
                          <span class="p-float-label mb-3">
                            <input [style]="{'width':'100%'}" formControlName="subsequentTermLengthMonths"
                              id="subsequentTermLengthMonths" type="number" pInputText>
                              <label for="subsequentTermLengthMonths">Subseq. Term (mo.)</label>
                              @for (validation of validationMessages.subsequentTermLengthMonths; track validation) {
                                <span>
                                  @if (form1.get('subsequentTermLengthMonths').hasError(validation.type) && (form1.get('subsequentTermLengthMonths').dirty || form1.get('subsequentTermLengthMonths').touched)) {
                                    <small class="p-invalid"
                                      >{{validation.message}}
                                    </small>
                                  }
                                </span>
                              }
                            </span>
                          </div>
                          <!-- <div class="col-lg-2">
                          <span class="p-float-label required-field mb-3">
                            <p-inputNumber [style]="{'width':'100%'}" formControlName="referralFeeAMT" [minFractionDigits]="2"
                              inputId="currency-us" mode="currency" currency="USD" locale="en-US">
                            </p-inputNumber>
                            <label for="referralFeeAMT">Realtor Referral Fee $</label>
                            <span *ngFor="let validation of validationMessages.referralFeeAMT">
                              <small class="p-invalid"
                                *ngIf="form1.get('referralFeeAMT').hasError(validation.type) && (form1.get('referralFeeAMT').dirty || form1.get('referralFeeAMT').touched)">{{validation.message}}
                              </small>
                            </span>
                          </span>
                        </div> -->
                        <!-- <div class="col-lg-2">
                        <span class="p-float-label mb-3">
                          <p-calendar [style]="{'width':'100%'}" formControlName="referralFeePaymentDate"
                            inputId="referralFeePaymentDate" appendTo="body">
                          </p-calendar>
                          <label for="referralFeePaymentDate">Date payment due</label>
                          <span *ngFor="let validation of validationMessages.referralFeePaymentDate">
                            <small class="p-invalid"
                              *ngIf="form1.get('referralFeePaymentDate').hasError(validation.type) && (form1.get('referralFeePaymentDate').dirty || form1.get('referralFeePaymentDate').touched)">{{validation.message}}
                            </small>
                          </span>
                        </span>
                      </div> -->
                      <div class="col-lg-2">
                        <span class="p-float-label required-field mb-3">
                          <p-dropdown [style]="{'width':'100%'}" [options]="percentages"
                            formControlName="mgmtFeePCT" optionLabel="name" optionValue="value"
                          placeholder="Management Fee %" [dropdownIcon]="'fa fa-caret-down'"></p-dropdown>
                          <label for="mgmtFeePCT">Mgmt Fee %</label>
                          @for (validation of validationMessages.mgmtFeePCT; track validation) {
                            <span>
                              @if (form1.get('mgmtFeePCT').hasError(validation.type) && (form1.get('mgmtFeePCT').dirty || form1.get('mgmtFeePCT').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                        @if (form1.get('proformaTemplateId')?.value) {
                          <small class="text-muted d-block" style="margin-top:-8px;font-size:0.72rem;">
                            Auto-calculated from template
                          </small>
                        }
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-2">
                        <span class="p-float-label required-field mb-3">
                          <p-inputNumber [style]="{'width':'100%'}" formControlName="estGrossRev"
                            [minFractionDigits]="2" inputId="currency-us" mode="currency" currency="USD"
                            locale="en-US">
                          </p-inputNumber>
                          <label for="estGrossRev">Estimated Gross Revenue $</label>
                          @for (validation of validationMessages.estGrossRev; track validation) {
                            <span>
                              @if (form1.get('estGrossRev').hasError(validation.type) && (form1.get('estGrossRev').dirty || form1.get('estGrossRev').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-2">
                        <span class="p-float-label mb-3">
                          <input [style]="{'width':'100%'}" formControlName="freeDepartureCleanNUM"
                            id="freeDepartureCleanNUM" type="number" pInputText>
                            <label for="freeDepartureCleanNUM">Free Dep. Cleans #</label>
                            @for (validation of validationMessages.freeDepartureCleanNUM; track validation) {
                              <span>
                                @if (form1.get('freeDepartureCleanNUM').hasError(validation.type) && (form1.get('freeDepartureCleanNUM').dirty || form1.get('freeDepartureCleanNUM').touched)) {
                                  <small class="p-invalid"
                                    >{{validation.message}}
                                  </small>
                                }
                              </span>
                            }
                          </span>
                        </div>
                        <!-- <div class="col-lg-3">
                        <span class="p-float-label required-field mb-3">
                          <p-inputNumber [style]="{'width':'100%'}" formControlName="ownerDepartureCleanFeeAMT"
                            [minFractionDigits]="2" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
                          </p-inputNumber>
                          <label for="ownerDepartureCleanFeeAMT">Homeowner Departure Cleaning $</label>
                          <span *ngFor="let validation of validationMessages.ownerDepartureCleanFeeAMT">
                            <small class="p-invalid"
                              *ngIf="form1.get('ownerDepartureCleanFeeAMT').hasError(validation.type) && (form1.get('ownerDepartureCleanFeeAMT').dirty || form1.get('ownerDepartureCleanFeeAMT').touched)">{{validation.message}}
                            </small>
                          </span>
                        </span>
                      </div> -->
                      <div class="col-lg-2">
                        <span class="p-float-label required-field mb-3">
                          <p-inputNumber [style]="{'width':'100%'}" formControlName="otherCreditAMT"
                            [minFractionDigits]="2" inputId="currency-us" mode="currency" currency="USD"
                            locale="en-US">
                          </p-inputNumber>
                          <label for="otherCreditAMT">Other Fees $</label>
                          @for (validation of validationMessages.otherCreditAMT; track validation) {
                            <span>
                              @if (form1.get('otherCreditAMT').hasError(validation.type) && (form1.get('otherCreditAMT').dirty || form1.get('otherCreditAMT').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <!-- <div class="col-lg-2">
                      <span class="p-float-label required-field mb-3">
                        <p-inputNumber [style]="{'width':'100%'}" formControlName="maxMaintFeeDiscretionAMT"
                          [minFractionDigits]="2" inputId="currency-us" mode="currency" currency="USD" locale="en-US">
                        </p-inputNumber>
                        <label for="maxMaintFeeDiscretionAMT">Maintenance Fee $</label>
                        <span *ngFor="let validation of validationMessages.maxMaintFeeDiscretionAMT">
                          <small class="p-invalid"
                            *ngIf="form1.get('maxMaintFeeDiscretionAMT').hasError(validation.type) && (form1.get('maxMaintFeeDiscretionAMT').dirty || form1.get('maxMaintFeeDiscretionAMT').touched)">{{validation.message}}
                          </small>
                        </span>
                      </span>
                    </div> -->
                    <div class="col-lg-2">
                      <span class="p-float-label mb-3">
                        <input [style]="{'width':'100%'}" formControlName="freeCarDaysNUM" id="freeCarDaysNUM"
                          type="number" pInputText>
                          <label for="freeCarDaysNUM">Free Car Days #</label>
                          @for (validation of validationMessages.freeCarDaysNUM; track validation) {
                            <span>
                              @if (form1.get('freeCarDaysNUM').hasError(validation.type) && (form1.get('freeCarDaysNUM').dirty || form1.get('freeCarDaysNUM').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <div class="col-lg-2">
                        <span class="p-float-label required-field mb-3">
                          <p-inputNumber [style]="{'width':'100%'}" formControlName="mgmtFeeCreditAMT"
                            [minFractionDigits]="2" inputId="currency-us" mode="currency" currency="USD"
                            locale="en-US">
                          </p-inputNumber>
                          <label for="mgmtFeeCreditAMT">Temp. Fee Waiver $</label>
                          @for (validation of validationMessages.mgmtFeeCreditAMT; track validation) {
                            <span>
                              @if (form1.get('mgmtFeeCreditAMT').hasError(validation.type) && (form1.get('mgmtFeeCreditAMT').dirty || form1.get('mgmtFeeCreditAMT').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6 p-1">
                        <div class="contract-modifications-right p-float-label">
                          <textarea [style]="{'width':'100%'}" formControlName="termsSummaryDesc"
                          id="termsSummaryDesc" pInputTextarea></textarea>
                          <label for="contractNote">Terms Summary Description</label>
                          @for (validation of validationMessages.termsSummaryDesc; track validation) {
                            <span>
                              @if (form1.get('termsSummaryDesc').hasError(validation.type) && (form1.get('termsSummaryDesc').dirty || form1.get('termsSummaryDesc').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="fw-bold my-2 title">Onboarding Credits</div>
                    <div class="row contract-modifications">
                      <div class="col-lg-2">
                        <span class="p-float-label required-field mb-3">
                          <p-inputNumber [style]="{'width':'100%'}" formControlName="upgradeCredit"
                            [minFractionDigits]="2" inputId="currency-us" mode="currency" currency="USD"
                            locale="en-US">
                          </p-inputNumber>
                          <label for="upgradeCredit">Upgrade Credit $</label>
                          @for (validation of validationMessages.upgradeCredit; track validation) {
                            <span>
                              @if (form1.get('upgradeCredit').hasError(validation.type) && (form1.get('upgradeCredit').dirty || form1.get('upgradeCredit').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </span>
                      </div>
                      <!-- <div class="col-lg-2">
                      <span class="p-float-label required-field mb-3">
                        <p-inputNumber [style]="{'width':'100%'}" formControlName="signOnBonus" [minFractionDigits]="2"
                          inputId="currency-us" mode="currency" currency="USD" locale="en-US">
                        </p-inputNumber>
                        <label for="signOnBonus">Sign On Bonus $</label>
                        <span *ngFor="let validation of validationMessages.signOnBonus">
                          <small class="p-invalid"
                            *ngIf="form1.get('signOnBonus').hasError(validation.type) && (form1.get('signOnBonus').dirty || form1.get('signOnBonus').touched)">{{validation.message}}
                          </small>
                        </span>
                      </span>
                    </div> -->
                    <div class="col-lg-2">
                      <span class="p-float-label required-field mb-3">
                        <p-inputNumber [style]="{'width':'100%'}" formControlName="signCreditAMT"
                          [minFractionDigits]="2" inputId="currency-us" mode="currency" currency="USD"
                          locale="en-US">
                        </p-inputNumber>
                        <label for="signCreditAMT">Sign-on Bonus (Amt/Due)</label>
                        @for (validation of validationMessages.signCreditAMT; track validation) {
                          <span>
                            @if (form1.get('signCreditAMT').hasError(validation.type) && (form1.get('signCreditAMT').dirty || form1.get('signCreditAMT').touched)) {
                              <small class="p-invalid"
                                >{{validation.message}}
                              </small>
                            }
                          </span>
                        }
                      </span>
                    </div>
                    <div class="col-lg-2">
                      <span class="p-float-label required-field mb-3">
                        <p-inputNumber [style]="{'width':'100%'}" formControlName="remodelCreditAMT"
                          [minFractionDigits]="2" inputId="currency-us" mode="currency" currency="USD"
                          locale="en-US">
                        </p-inputNumber>
                        <label for="remodelCreditAMT">Furn/Other Credit (Amt/Due)</label>
                        @for (validation of validationMessages.remodelCreditAMT; track validation) {
                          <span>
                            @if (form1.get('remodelCreditAMT').hasError(validation.type) && (form1.get('remodelCreditAMT').dirty || form1.get('remodelCreditAMT').touched)) {
                              <small class="p-invalid"
                                >{{validation.message}}
                              </small>
                            }
                          </span>
                        }
                      </span>
                    </div>
                  </div>
                  <div class="row">
                  </div>
                </div>
                @if (proformaId) {
                  <div class="mt-3">
                    <app-tag-join-select [isPublicAndPublish]="isPublicAndPublish" [tagSource]="70"
                      [tagSourceId]="proformaId" tagType="4">
                    </app-tag-join-select>
                  </div>
                }
              </div>
            }
          </div>

          @if (!isRequestedProforma) {
            <div>
              @if (proformaId) {
                <hr>
                }
                @if (proformaId) {
                  <div>
                    <div class="col-lg-12">
                      <h6>Proforma Income</h6>
                      <h6 class="col-lg-12 mt-1 mb-3 text-center" data-html2canvas-ignore="true"
                      style="white-space: pre; color:red;">{{dateOverLappingMsg}}</h6>
                    </div>
                    @if (proformaId) {
                      <app-proforma-income-list [proformaId]="proformaId" [updateIncome]="updateIncome"
                        [isPublicAndPublish]="isPublicAndPublish" [showFilter]="false" [showPagination]="false"
                        (doUpdate)="doUpdateProformaList($event)"
                      (getMetaInfo)="onGetMetaInfo($event)"></app-proforma-income-list>
                    }
                  </div>
                }
                @if (proformaId) {
                  <hr>
                  }
                  @if (proformaId) {
                    <div>
                      <div class="col-lg-12">
                        <h6>Proforma Expense</h6>
                      </div>
                      @if (proformaId) {
                        <app-proforma-expense-list [proformaId]="proformaId" [showFilter]="false"
                        [isPublicAndPublish]="isPublicAndPublish" [showPagination]="false"></app-proforma-expense-list>
                      }
                    </div>
                  }
                  @if (proformaId) {
                    <hr>
                    }
                    <div class="row">
                      @if (proformaId) {
                        <div class="col-lg-12">
                          <app-note-list [isPublicAndPublish]="isPublicAndPublish" [noteSource]="70"
                          [noteSourceId]="proformaId" (messageEvent)="setAssignedToUserId($event)"></app-note-list>
                        </div>
                      }
                    </div>
                    <hr>
                      <div class="row m-0">
                        <div class="col-lg-12">
                          <div class="btn-group">
                            <div class="button-group">
                              @if (proformaId && !isPublicAndPublish) {
                                <button pButton
                                  class="btn-delete p-button-outlined p-button-danger" (click)="onFormDelete()">Delete
                                Proforma</button>
                              }
                            </div>
                            <div class="button-group">
                              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
                              @if (!proformaId) {
                                <button pButton class="btn-addt p-button" (click)="formAdd()">Add
                                Proforma</button>
                              }
                              @if (proformaId && !isPublicAndPublish) {
                                <button pButton class="btn-upt p-button"
                                  (click)="formUpdate()">Update
                                Proforma</button>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </mat-tab>

            <!-- HISTORY TAB -->
            @if (proformaId) {
              <mat-tab label="History">
                <ng-template matTabContent>
                  <app-audit-list
                    [auditUrl]="'proformas/' + proformaId + '/audit'">
                  </app-audit-list>
                </ng-template>
              </mat-tab>
            }

          </mat-tab-group>
        </div>